import { Skeleton } from "@/components/ui/skeleton";

const MyDietSkeleton = () => {
  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      {/* Summary Cards */}
      <div className="bg-card rounded-2xl p-5 shadow-card border border-border">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <Skeleton className="w-10 h-10 rounded-xl" />
            <div>
              <Skeleton className="h-4 w-32 mb-2" />
              <Skeleton className="h-6 w-44" />
            </div>
          </div>
          <Skeleton className="h-9 w-28 rounded-lg" />
        </div>
        <Skeleton className="w-full h-2.5 rounded-full mb-4" />
        <div className="grid grid-cols-3 gap-3">
          {[1, 2, 3].map(i => (
            <div key={i} className="bg-muted/50 rounded-xl p-3 text-center">
              <Skeleton className="h-5 w-12 mx-auto mb-1" />
              <Skeleton className="h-3 w-16 mx-auto" />
            </div>
          ))}
        </div>
      </div>

      {/* Meal Blocks */}
      {[1, 2, 3, 4, 5].map(i => (
        <div key={i} className="bg-card rounded-2xl shadow-card border border-border">
          <div className="flex items-center justify-between p-5">
            <div className="flex items-center gap-3">
              <Skeleton className="w-8 h-8 rounded-lg" />
              <div>
                <Skeleton className="h-5 w-32 mb-1" />
                <Skeleton className="h-3 w-48" />
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-7 w-20 rounded-full" />
              <Skeleton className="h-7 w-14 rounded-full" />
              <Skeleton className="w-5 h-5 rounded" />
            </div>
          </div>
          {i <= 2 && (
            <div className="px-5 pb-5 space-y-3">
              <div className="flex gap-2 overflow-hidden">
                {[1, 2, 3].map(j => (
                  <Skeleton key={j} className="h-8 w-28 rounded-full flex-shrink-0" />
                ))}
              </div>
              <div className="space-y-2">
                {[1, 2, 3].map(j => (
                  <div key={j} className="flex items-center gap-3 p-3 bg-muted/30 rounded-xl">
                    <Skeleton className="w-8 h-8 rounded-lg flex-shrink-0" />
                    <div className="flex-1">
                      <Skeleton className="h-4 w-36 mb-1" />
                      <Skeleton className="h-3 w-48" />
                    </div>
                    <Skeleton className="h-4 w-16" />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MyDietSkeleton;
